import { DialogComponent } from '@theme/dialog';
import { CartAddEvent, ThemeEvents } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  #handleCartUpdate = () => {
    // Replace currency after cart updates
    this.#replaceCurrency();
  };

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });

    // Replace CRC with жълтици
    this.#replaceCurrency();
  }

  /**
   * Replaces "CRC" with "жълтици" throughout the cart drawer
   */
  #replaceCurrency() {
    requestAnimationFrame(() => {
      const drawer = this.querySelector('.cart-drawer__dialog');
      if (!drawer) return;

      // Get all text nodes and replace CRC with жълтици
      const walker = document.createTreeWalker(
        drawer,
        NodeFilter.SHOW_TEXT,
        null
      );

      const nodesToUpdate = [];
      let node;
      while (node = walker.nextNode()) {
        if (node.textContent && node.textContent.includes('CRC')) {
          nodesToUpdate.push(node);
        }
      }

      nodesToUpdate.forEach(node => {
        if (node.textContent) {
          node.textContent = node.textContent.replace(/CRC/g, 'жълтици');
        }
      });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
